import React from 'react';
import PropTypes from 'prop-types';

const onInputChange = (e, onSearch) => {
  const checked = e.target.checked;
  if (onSearch) {
    onSearch(checked);
  }
};

const SearchCheckbox = ({ onSearch, value }) => {
  return (
    <div>
      <input 
        title={value}
        type="checkbox" 
        className="filter form-control form-control-sm" onChange={(e) => onInputChange(e, onSearch)}/>
    </div>
  )
};

SearchCheckbox.propTypes = {
  onSearch: PropTypes.func
};

export default SearchCheckbox;


// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/validator-table/search-checkbox.js